const {Math, Number} = globalThis;

/** Berechnet den nächstmöglichen Scale-Wert, welcher einen Wert ohne Nachkommastellen erzeugt
 * @alias task.createIntegerScale
 * @param {number} baseValue
 * @param {number} startScaleValue
 * @param {number} [decimalPlaces=4]
 * @return {number} bestScaleValue
 */
export default function(baseVal, scale, decimalPlaces = 4)
{
    const fractionFactor = 10 ** decimalPlaces;
    const baseScale = Math.round(scale * fractionFactor);
    let foundScale = null;
    let checkUp = true;
    let roundUp = baseScale;
    let roundDown = baseScale - 1;

    while (!foundScale)
    {
        let refScale = null;
        if (checkUp)
        {
            refScale = roundUp;
            roundUp++;
        }
        else
        {
            refScale = roundDown;
            roundDown--;
        }

        checkUp = !checkUp;

        if (Number.isInteger((baseVal * refScale) / fractionFactor))
        {
            foundScale = refScale / fractionFactor;
        }
    }

    return foundScale;
}
